import React, { useState } from "react";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import { IconButton, useMediaQuery } from "@mui/material";
import { Card } from "@mui/material";
import pic1 from "./Media/WhatsApp Image 2024-01-11 at 11.26.16 AM.jpeg";
import pic2 from "./Media/WhatsApp Image 2024-01-11 at 11.26.17 AM (1).jpeg";
import pic3 from "./Media/WhatsApp Image 2024-01-11 at 11.26.17 AM (2).jpeg";
import pic4 from "./Media/WhatsApp Image 2024-01-11 at 11.26.17 AM.jpeg";
import pic5 from "./Media/WhatsApp Image 2024-01-11 at 11.26.18 AM (1).jpeg";
import pic6 from "./Media/WhatsApp Image 2024-01-11 at 11.26.19 AM.jpeg";
import pic7 from "./Media/1.jpeg";
import pic8 from "./Media/2.jpeg";
import pic9 from "./Media/3.jpeg";
import pic10 from "./Media/4.jpeg";
import pic11 from "./Media/5.jpeg";
import pic12 from "./Media/6.jpeg";
import pic13 from "./Media/7.jpeg";
import pic14 from "./Media/8.jpeg";
import pic15 from "./Media/9.jpeg";
import pic16 from "./Media/10.jpeg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useTranslation } from "react-i18next";
import { Carousel } from "react-responsive-carousel";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";

const images = [
  {
    imgPath: pic1,
  },
  {
    imgPath: pic2,
  },
  {
    imgPath: pic3,
  },
  {
    imgPath: pic4,
  },
  {
    imgPath: pic5,
  },
  {
    imgPath: pic6,
  },
  {
    imgPath: pic7,
  },
  {
    imgPath: pic8,
  },
  {
    imgPath: pic9,
  },
  {
    imgPath: pic10,
  },
  {
    imgPath: pic11,
  },
  {
    imgPath: pic12,
  },
  {
    imgPath: pic13,
  },
  {
    imgPath: pic14,
  },
  {
    imgPath: pic15,
  },
  {
    imgPath: pic16,
  },
];

function ProjectsSliders() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const istabScreen = useMediaQuery(
    "(min-width: 769px) and (max-width: 992px)"
  );
  const isMdScreen = useMediaQuery(
    "(min-width: 993px) and (max-width: 1200px)"
  );

  const [intervalz, setIntervalz] = useState(2000);

  const onChange = (index, item) => {
    setIntervalz(item.props["data-interval"]);
  };

  return (
    <Box sx={{ maxWidth: "100%", flexGrow: 1, mb: 5, position: "relative" }}>
      <Box
        sx={{
          display: "flex",
          color: "white",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "100px",
        }}
      >
        <Typography sx={{ fontSize: "35px", mb: "35px" }}>
          {t("Social Media")}
        </Typography>
      </Box>

      <Carousel
        onChange={onChange}
        infiniteLoop={true}
        showThumbs={false} // Show thumbnails
        showIndicators={false}
        showStatus={false}
        autoPlay
        interval={intervalz}
        renderArrowPrev={(onClickHandler, hasPrev, lable) => (
          <IconButton
            onClick={onClickHandler}
            sx={{
              position: "absolute",
              top: "50%",
              left: "0",
              color: "white",
              padding: "5px",
              zIndex: "10",
              transform: "translateY(-50%)",
            }}
          >
            <NavigateBefore sx={{ fontSize: "40px" }} />
          </IconButton>
        )}
        renderArrowNext={(onClickHandler, hasNext, lable) => (
          <IconButton
            onClick={onClickHandler}
            sx={{
              position: "absolute",
              top: "50%",
              right: "0",
              color: "white",
              padding: "5px",
              zIndex: "10",
              transform: "translateY(-50%)",
            }}
          >
            <NavigateNext sx={{ fontSize: "40px" }} />
          </IconButton>
        )}
        showArrows={true}
        dynamicHeight={false}
        centerMode={true} // Center the current slide
        centerSlidePercentage={
          isMdScreen ? 33.33 : istabScreen ? 50 : isMobile ? 100 : 25
        }
      >
        {Object.values(images).map((image, index) => (
          <Box
            key={`carousel-image-${index}`}
            data-interval={2000}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <Card
              sx={{
                maxWidth: "300px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                margin: "0 10px", // Add margin to create a gap between cards
                borderRadius: "10px", // Apply border radius to each card
              }}
            >
              <img
                src={image.imgPath}
                alt={`carousel-${index}`}
                style={{
                  width: "100%",
                  height: "auto", // Adjust the height of the images
                  objectFit: "cover",
                  borderRadius: "10px", // Apply border radius to the image
                }}
              />
            </Card>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}

export default ProjectsSliders;
